<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    컬렉션 상세정보
                </div>
                <div class="write_tab">
                    <div class="write_tab_content tab_payment_detail" @click="movePage()">
                        상세정보
                    </div>
                    <div class="write_tab_content tab_payment_detail" @click="moveItem()">
                        아이템
                    </div>
                  <div class="write_tab_content tab_payment_detail active">
                    유틸리티
                  </div>
                </div>
                <div class="member_write_wrap">
                    <div class="write_content">
                        <div class="write_box">
                          <utility-list-item-component :utilityType="`collectionUtility`" :itemKey="itemKey"></utility-list-item-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ItemWriteComponent from "@/components/item/ItemWriteComponent";
import EventBus from "@/utils/event-bus";
import ItemWriteCollectionComponent from "@/components/item/ItemWriteCollectionComponent";
import UtilityListItemComponent from "@/components/utility/UtilityListItemComponent";

export default {
    name: "ItemCollectionDetailUtility",
    mixins: [],
    components: {
        ItemWriteCollectionComponent,
        ItemWriteComponent,
      UtilityListItemComponent,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            itemKey: this.$route.params.idx
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        writeItem() {
            EventBus.$emit('writeCollection')
        },
        movePage() {
            this.$router.push(`/item/collection/${this.itemKey}`)
        },
      moveItem() {
        this.$router.push(`/item/collection/${this.itemKey}/item`)
      },
    },
    watch: {},
}
</script>

<style scoped>

</style>
